var render = function render(_c, _vm) {
  return _c(
    "svg",
    {
      attrs: {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("Icon / Trash")]),
      _vm._v(" "),
      _c("desc", [_vm._v("Created with Sketch.")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Icon-/-Trash",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c("path", {
            attrs: {
              id: "trash-copy-7",
              d: "M13.118701,14.3824511 C13.0638298,15.3514545 12.3740202,16 11.3784994,16 L4.62933931,16 C3.62597984,16 2.94400896,15.3590844 2.89697648,14.3900811 L2.36394177,3.68526466 L1.47816349,3.68526466 C1.21948488,3.68526466 1,3.47162613 1,3.21983786 C1,2.96041965 1.21948488,2.74678112 1.47816349,2.74678112 L4.80963046,2.74678112 L4.80963046,1.64043872 C4.80963046,0.648545541 5.49944009,0 6.5968645,0 L9.39529675,0 C10.4927212,0 11.1903695,0.648545541 11.1903695,1.64043872 L11.1903695,2.74678112 L14.5296753,2.74678112 C14.7883539,2.74678112 15,2.96041965 15,3.21983786 C15,3.47162613 14.7883539,3.68526466 14.5296753,3.68526466 L13.6517357,3.68526466 L13.118701,14.3824511 Z M5.82866741,1.69384835 L5.82866741,2.74678112 L10.1713326,2.74678112 L10.1713326,1.69384835 C10.1713326,1.24368145 9.83426652,0.915593705 9.32474804,0.915593705 L6.66741321,0.915593705 C6.16573348,0.915593705 5.82866741,1.24368145 5.82866741,1.69384835 Z M4.71556551,15.0691464 L11.2844345,15.0691464 C11.7469205,15.0691464 12.0996641,14.7334287 12.1153415,14.2832618 L12.6326988,3.68526466 L3.35946249,3.68526466 L3.8924972,14.2832618 C3.91601344,14.7257988 4.268757,15.0691464 4.71556551,15.0691464 Z M10.2105263,13.7110157 C9.99104143,13.7110157 9.82642777,13.527897 9.83426652,13.2989986 L10.0694289,5.50119218 C10.0772676,5.27229375 10.2418813,5.09680496 10.4456887,5.09680496 C10.6730123,5.09680496 10.8297872,5.27229375 10.8297872,5.50882213 L10.5946249,13.3066285 C10.5867861,13.5431569 10.4300112,13.7110157 10.2105263,13.7110157 Z M5.79731243,13.7110157 C5.57782755,13.7110157 5.42105263,13.5431569 5.41321389,13.3066285 L5.17805151,5.50882213 C5.17805151,5.27229375 5.33482643,5.09680496 5.55431131,5.09680496 C5.7581187,5.09680496 5.93057111,5.27229375 5.93840985,5.50119218 L6.17357223,13.2989986 C6.18141097,13.527897 6.01679731,13.7110157 5.79731243,13.7110157 Z M8.39977604,13.2989986 C8.39977604,13.527897 8.21948488,13.7110157 8.00783875,13.7110157 C7.79619261,13.7110157 7.61590146,13.527897 7.61590146,13.2989986 L7.61590146,5.50119218 C7.61590146,5.27229375 7.79619261,5.09680496 8.00783875,5.09680496 C8.21948488,5.09680496 8.39977604,5.27229375 8.39977604,5.50119218 L8.39977604,13.2989986 Z",
              fill: "#2F477C",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }